// extracted by mini-css-extract-plugin
module.exports = {"notfound":"Notfound_notfound__C_noq","button":"Notfound_button__pUhgZ"};